const WORDS = ['Disciplina', 'Foco', 'Constância', 'Hábitos', 'Mentalidade', 'Propósito'];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 bg-[#060606] py-6">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex w-max items-center">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-display text-2xl font-light uppercase tracking-[0.3em] text-neutral-600 sm:text-3xl">
                  {w}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#030303] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#030303] to-transparent" />
    </div>
  );
};
